import _ from 'lodash';
import createReducer from '../lib/createReducer';
import * as types from '../actions/types';
import utils from '../lib/utils';
import { addSchedule, getSchedule } from '../actions/schedules';

export const schedules = createReducer(
  {
    list: [],
    availability: [],
    schedule: {
      appointments: [],
      staff_schedule: [],
    },
    procedure_codes: [],
    serviceTypeDetails: [],
    servicetypes: [],
    getProcedureCodes: false,
    getServiceTypeDetails: false,
    addServiceType: false,
    addServiceSuccess: false,
    editServiceType: false,
    editServiceSuccess: false,
    deleteServiceType: false,
    deleteServiceSuccess: false,
    syncBusiness: false,
    syncSuccess: false,
    updateBusinessData: false,
    errorMessage: null,
    scheduleDefinition: [],
    staff_list: [],
    scheduleDefinitionFetch: false,
    addScheduleDefinition: false,
    deleteScheduleDefinition: false,
    deleteScheduleDefinitionSuccess: false,
    addScheduleDefinitionSuccess: false,
    scheduleBlocks: [],
    getScheduleBlocks: false,
    getScheduleBlocksSuccess: false,
    addScheduleBlocks: false,
    addScheduleBlocksSuccess: false,
    deleteScheduleBlocks: false,
    deleteScheduleBlocksSuccess: false,
    addScheduleBlocksfail: false,
  },
  {
    [types.GET_SCHEDULES_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });

      return newState;
    },
    [types.GET_SCHEDULES_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        list: action.schedules,
        staffMembers: action.staffMembers,
        loading: false,
      });
      return newState;
    },
    [types.GET_SCHEDULES_FAIL](state) {
      const newState = Object.assign({}, state, {
        list: [],
        loading: false,
      });

      return newState;
    },
    [types.GET_DENTAL_SCHEDULES_START](state) {
      const newState = Object.assign({}, state, {
        loading: true,
      });

      return newState;
    },
    [types.GET_DENTAL_SCHEDULES_SUCCESS](state, action) {
      console.log('action.availability', action);
      const newState = Object.assign({}, state, {
        availability: action.availability,
        schedule: action.schedule,
        loading: false,
      });
      return newState;
    },
    [types.GET_DENTAL_SCHEDULES_FAIL](state) {
      const newState = Object.assign({}, state, {
        availability: [],
        schedule: {
          appointments: [],
          staff_schedule: [],
        },
        loading: false,
      });

      return newState;
    },
    [types.GET_PROCEDURE_CODES_START](state) {
      const newState = Object.assign({}, state, {
        getProcedureCodes: true,
      });

      return newState;
    },
    [types.GET_PROCEDURE_CODES_SUCCESS](state, action) {
      console.log('action.availability', action);
      const newState = Object.assign({}, state, {
        procedure_codes: action.procedure_codes,
        getProcedureCodes: false,
      });
      return newState;
    },
    [types.GET_PROCEDURE_CODES_FAIL](state) {
      const newState = Object.assign({}, state, {
        procedure_codes: [],
        getProcedureCodes: false,
      });

      return newState;
    },
    [types.GET_SERVICE_TYPE_DETAILS_START](state) {
      const newState = Object.assign({}, state, {
        getServiceTypeDetails: true,
      });

      return newState;
    },
    [types.GET_SERVICE_TYPE_DETAILS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        serviceTypeDetails: action.serviceTypeDetails,
        getServiceTypeDetails: false,
      });

      return newState;
    },
    [types.GET_SERVICE_TYPE_DETAILS_FAIL](state) {
      const newState = Object.assign({}, state, {
        serviceTypeDetails: [],
        getServiceTypeDetails: false,
      });

      return newState;
    },
    [types.ADD_SERVICE_TYPES_START](state) {
      const newState = Object.assign({}, state, {
        addServiceType: true,
        addServiceSuccess: false,
        errorMessage: null,
      });

      return newState;
    },
    [types.ADD_SERVICE_TYPES_SUCCESS](state, action) {
      const newServicetypes = state.servicetypes.slice();
      newServicetypes.push(action.service);
      const newState = Object.assign({}, state, {
        addServiceType: false,
        updateBusinessData: true,
        addServiceSuccess: true,
        servicetypes: newServicetypes,
      });
      return newState;
    },
    [types.ADD_SERVICE_TYPES_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        addServiceType: false,
        errorMessage: action.error,
      });
      return newState;
    },
    [types.EDIT_SERVICE_TYPES_START](state) {
      const newState = Object.assign({}, state, {
        editServiceType: true,
        editServiceSuccess: false,
        errorMessage: null,
      });

      return newState;
    },
    [types.EDIT_SERVICE_TYPES_SUCCESS](state, action) {
      let services = state.servicetypes.slice();
      services = services.filter((service) => service.id !== action.service.id);
      services.push(action.service);
      const newState = Object.assign({}, state, {
        editServiceType: false,
        updateBusinessData: true,
        editServiceSuccess: true,
        servicetypes: services,
      });
      return newState;
    },
    [types.EDIT_SERVICE_TYPES_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        editServiceType: false,
        errorMessage: action.error,
      });
      return newState;
    },
    [types.DELETE_SERVICE_TYPES_START](state) {
      const newState = Object.assign({}, state, {
        deleteServiceType: true,
        deleteServiceSuccess: false,
        errorMessage: null,
      });

      return newState;
    },
    [types.DELETE_SERVICE_TYPES_SUCCESS](state, action) {
      let services = state.servicetypes.slice();
      services = services.filter((service) => service.id !== action.service.id);
      const newState = Object.assign({}, state, {
        deleteServiceType: false,
        updateBusinessData: true,
        deleteServiceSuccess: true,
        servicetypes: services,
      });
      return newState;
    },
    [types.DELETE_SERVICE_TYPES_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        deleteServiceType: false,
        deleteServiceSuccess: false,
        errorMessage: action.error,
      });
      return newState;
    },
    [types.SYNC_BUSINESS_START](state) {
      const newState = Object.assign({}, state, {
        syncBusiness: true,
        syncSuccess: false,
        updateBusinessData: false,
      });

      return newState;
    },
    [types.SYNC_BUSINESS_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        syncBusiness: false,
        syncSuccess: true,
        updateBusinessData: false,
      });
      return newState;
    },
    [types.SYNC_BUSINESS_FAIL](state) {
      const newState = Object.assign({}, state, {
        syncBusiness: false,
        updateBusinessData: false,
      });
      return newState;
    },
    [types.UPDATE_SERVICE_MAPPING_START](state) {
      const newState = Object.assign({}, state, {
        syncBusiness: true,
        syncSuccess: false,
        updateBusinessData: false,
      });

      return newState;
    },
    [types.UPDATE_SERVICE_MAPPING_SUCCESS](state) {
      const newState = Object.assign({}, state, {
        syncBusiness: false,
        syncSuccess: true,
        updateBusinessData: false,
      });
      return newState;
    },
    [types.UPDATE_SERVICE_MAPPING_FAIL](state) {
      const newState = Object.assign({}, state, {
        syncBusiness: false,
        updateBusinessData: false,
      });
      return newState;
    },
    [types.STORE_SERVICE_TYPES](state, actions) {
      const newState = Object.assign({}, state, {
        servicetypes: actions.services,
      });
      return newState;
    },
    [types.CLEAR_SERVICE_TYPES_FLAG](state) {
      const newState = Object.assign({}, state, {
        errorMessage: null,
      });
      return newState;
    },
    [types.GET_SCHEDULE_DEFINITION_START](state) {
      const newState = Object.assign({}, state, {
        scheduleDefinition: [],
        scheduleDefinitionFetch: true,
      });

      return newState;
    },
    [types.GET_SCHEDULE_DEFINITION_SUCCESS](state, actions) {
      const newState = Object.assign({}, state, {
        scheduleDefinition: actions.scheduleDefinition.staff_schedule,
        staff_list: actions.scheduleDefinition.staff_list,
        scheduleDefinitionFetch: false,
      });
      return newState;
    },
    [types.GET_SCHEDULE_DEFINITION_FAIL](state) {
      const newState = Object.assign({}, state, {
        scheduleDefinition: [],
        scheduleDefinitionFetch: false,
      });
      return newState;
    },
    [types.ADD_DEFINITION_START](state) {
      const newState = Object.assign({}, state, {
        addScheduleDefinition: true,
        addScheduleDefinitionSuccess: false,
        errorMessage: null,
      });

      return newState;
    },
    [types.ADD_DEFINITION_SUCCESS](state, actions) {
      let staff_scheduletemp = state.scheduleDefinition.staff_schedules.slice();

      staff_scheduletemp = [
        ...staff_scheduletemp,
        ...utils.ensureArray(actions.scheduleDefinition),
      ]
        .reduce((acc, obj) => {
          acc.set(obj.id, obj);
          return acc;
        }, new Map())
        .values();

      staff_scheduletemp = Array.from(staff_scheduletemp);

      let addScheduleDefinitionSuccess = true;
      let errorMessage = 'Something went wrong. Operation was unsuccessful';

      const newState = Object.assign({}, state, {
        scheduleDefinition: { staff_schedules: staff_scheduletemp },
        addScheduleDefinition: false,
        addScheduleDefinitionSuccess,
        errorMessage,
      });
      return newState;
    },
    [types.ADD_DEFINITION_FAIL](state) {
      let errorMessage = 'Something went wrong. Operation was unsuccessful';
      const newState = Object.assign({}, state, {
        addScheduleDefinition: false,
        addScheduleDefinitionSuccess: false,
        errorMessage,
      });
      return newState;
    },
    [types.DELETE_DEFINITION_START](state) {
      const newState = Object.assign({}, state, {
        deleteScheduleDefinition: true,
        deleteScheduleDefinitionSuccess: false,
        errorMessage: null,
      });

      return newState;
    },
    [types.DELETE_DEFINITION_SUCCESS](state, actions) {
      const { schedule_id } = actions.data;
      let staff_scheduletemp = state.scheduleDefinition.staff_schedules.slice();
      staff_scheduletemp = staff_scheduletemp.filter(
        (schedule) => schedule.id !== schedule_id,
      );
      console.log('Response', staff_scheduletemp);
      const newState = Object.assign({}, state, {
        scheduleDefinition: { staff_schedules: staff_scheduletemp },
        deleteScheduleDefinition: false,
        deleteScheduleDefinitionSuccess: true,
      });
      return newState;
    },
    [types.DELETE_DEFINITION_FAIL](state) {
      const newState = Object.assign({}, state, {
        deleteScheduleDefinition: false,
        deleteScheduleDefinitionSuccess: false,
      });
      return newState;
    },

    [types.GET_BLOCK_RULES_START](state) {
      const newState = Object.assign({}, state, {
        getScheduleBlocks: true,
      });

      return newState;
    },
    [types.GET_BLOCK_RULES_SUCCESS](state, actions) {
      console.log('Response', actions.blockRules);
      const newState = Object.assign({}, state, {
        scheduleBlocks: actions.blockRules,
        getScheduleBlocks: false,
        getScheduleBlocksSuccess: true,
      });
      return newState;
    },
    [types.GET_BLOCK_RULES_FAIL](state) {
      const newState = Object.assign({}, state, {
        getScheduleBlocks: false,
        getScheduleBlocksSuccess: false,
      });
      return newState;
    },
    [types.ADD_BLOCK_RULES_START](state) {
      const newState = Object.assign({}, state, {
        addScheduleBlocks: true,
        addScheduleBlocksfail: false,
      });

      return newState;
    },
    [types.ADD_BLOCK_RULES_SUCCESS](state, actions) {
      console.log('Response', actions.blockRules);
      const updated = {
        [actions?.blockRules?.rule_id]: actions?.blockRules?.rule_meta_data,
      };
      const updateScheduleBlock = { ...state.scheduleBlocks, ...updated };
      const newState = Object.assign({}, state, {
        scheduleBlocks: updateScheduleBlock,
        addScheduleBlocks: false,
        addScheduleBlocksSuccess: true,
      });
      return newState;
    },
    [types.ADD_BLOCK_RULES_FAIL](state) {
      const newState = Object.assign({}, state, {
        addScheduleBlocks: false,
        addScheduleBlocksSuccess: false,
        addScheduleBlocksfail: true,
      });
      return newState;
    },

    [types.UPDATE_BLOCK_RULES_START](state) {
      const newState = Object.assign({}, state, {
        addScheduleBlocks: true,
      });

      return newState;
    },
    [types.UPDATE_BLOCK_RULES_SUCCESS](state, actions) {
      const updated = {
        [actions?.blockRules?.rule_id]: actions?.blockRules?.rule_meta_data,
      };
      const updateScheduleBlock = { ...state.scheduleBlocks, ...updated };
      console.log('Response', updateScheduleBlock);
      const newState = Object.assign({}, state, {
        addScheduleBlocks: false,
        addScheduleBlocksSuccess: true,
        scheduleBlocks: updateScheduleBlock,
      });
      return newState;
    },
    [types.UPDATE_BLOCK_RULES_FAIL](state) {
      const newState = Object.assign({}, state, {
        addScheduleBlocks: false,
        addScheduleBlocksSuccess: false,
      });
      return newState;
    },

    [types.DELETE_BLOCK_RULES_START](state) {
      const newState = Object.assign({}, state, {
        deleteScheduleBlocks: true,
      });

      return newState;
    },
    [types.DELETE_BLOCK_RULES_SUCCESS](state, actions) {
      console.log('Response', actions.blockRules);
      const updateScheduleBlock = _.cloneDeep(state.scheduleBlocks);
      delete updateScheduleBlock[actions?.blockRules?.rule_id];
      const newState = Object.assign({}, state, {
        deleteScheduleBlocks: false,
        deleteScheduleBlocksSuccess: true,
        scheduleBlocks: updateScheduleBlock,
      });
      return newState;
    },
    [types.DELETE_BLOCK_RULES_FAIL](state) {
      const newState = Object.assign({}, state, {
        deleteScheduleBlocks: false,
        deleteScheduleBlocksSuccess: false,
      });
      return newState;
    },
  },
);
export { schedules as default };
